<template>
	<div class="login-page">
		<div class="login-card">
			<div class="title">
				<h1>AI智能体课堂互动平台</h1>
				<p>学校端</p>
			</div>

			<div class="tabs">
				<button @click="type = 'student'" :class="type == 'student' ? 'active' : ''">
					学生登录
				</button>
				<button @click="type = 'teacher'" :class="type == 'teacher' ? 'active' : ''">
					教师登录
				</button>
			</div>

			<student-login v-if="type == 'student'" @success="toStudent" />
			<teacher-login v-else @success="toTeacher" :qr-token="qrLoginToken" />
		</div>
		<div style="bottom: 10px;position: absolute;justify-content: center;align-items: center;">
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a2c4g.11186623.0.0.72db6a37I8amZE"
				target="_blank" >
				<img style="width: 20px;vertical-align:top" src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
					:alt="gov" loading="lazy"
					><span
					>{{gov}}</span></a>
			<a href="https://beian.miit.gov.cn/?spm=5176.beian-pc.J_9220772140.J_4NWEMkQ5nDwOgLi8EJmHs.61"
				target="_blank"><span>{{icp}}</span></a>
		</div>
		<template  v-if="type=='teacher'">
		  <div class="business-wrap">
		    <!-- 文字触发区域 -->
		    <div class="business-text">商务联系</div>
		    <!-- hover展示图片 -->
		    <img class="business-img" src="@/ico/BusinessContact.png" alt="商务联系" />
		  </div>
		</template>
	</div>
</template>

<script>
	import StudentLogin from './student/Login.vue'
	import TeacherLogin from './teacher/Login.vue'

	export default {
		components: {
			StudentLogin,
			TeacherLogin
		},
		data() {
			return {
				type: 'student',
				// 传给子组件的 token
				qrLoginToken: null,
				icp:'浙ICP备2026065847号-1',
				gov:null
			}
		},
		created() {
			this.type = this.$route.query.type || 'student'
		},
		watch: {
			$route: {
				handler() {
					this.checkQrParams()
				},
				immediate: true
			}
		},
		methods: {
			// ======================
			// 纯校验，不登录
			// ======================
			checkQrParams() {

				const query = this.$route.query

				const type = query.type
				const token = query.token
				const time = query.time
				if (!token || !time) {
					this.qrLoginToken = null
					return
				}

				// 必须是教师
				if (type !== 'teacher') return
				localStorage.clear()
				// 3分钟过期
				const now = Date.now()
				const qrTime = Number(time)
				const THREE_MIN = 3 * 60 * 1000
				if (now - qrTime > THREE_MIN) {
					this.$message.warning('二维码已过期')
					return
				}

				this.type = 'teacher'
				this.qrLoginToken = token
			},

			toStudent() {
				this.$router.push('/student/home')
			},
			toTeacher() {
				this.$router.push('/teacher/dashboard')
			}
		}
	}
</script>

<style scoped>
	.login-page {
		width: 100vw;
		height: 100vh;
		padding: 24px;
		box-sizing: border-box;
		background:
			radial-gradient(circle at 12% 10%, rgba(255, 255, 255, .55), transparent 28%),
			linear-gradient(120deg, #87ceeb, #98fb98);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.login-card {
		width: min(420px, 100%);
		min-height: 430px;
		background: rgba(255, 255, 255, .92);
		padding: 30px;
		border-radius: 18px;
		box-shadow: 0 24px 60px rgba(31, 65, 105, .18);
		border: 1px solid rgba(255, 255, 255, .72);
		backdrop-filter: blur(10px);
		box-sizing: border-box;
	}

	.title {
		text-align: center;
		margin-bottom: 20px;
	}

	.tabs {
		display: flex;
		margin-bottom: 20px;
		padding: 5px;
		border-radius: 12px;
		background: #f3f7fb;
	}

	.tabs button {
		flex: 1;
		height: 40px;
		padding: 0 10px;
		border: none;
		border-radius: 9px;
		background: transparent;
		color: #526174;
		font-weight: 700;
		cursor: pointer;
	}

	.tabs button.active {
		background: linear-gradient(135deg, #2d8cf0, #42b4f5);
		color: #fff;
		box-shadow: 0 8px 18px rgba(45, 140, 240, .25);
	}

	.login-card>>>.student-login,
	.login-card>>>.teacher-login {
		width: 100%;
		min-height: 240px;
		padding: 0;
		box-sizing: border-box;
	}

	.login-card>>>.tab {
		display: flex;
		gap: 6px;
		min-height: 38px;
		margin-bottom: 16px;
		padding: 4px;
		border-radius: 11px;
		background: #f5f8fc;
	}

	.login-card>>>.tab span {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 0;
		min-height: 30px;
		padding: 0 8px;
		border-radius: 8px;
		font-size: 14px;
		color: #5d6b7c;
		white-space: nowrap;
	}

	.login-card>>>.tab span.on {
		background: #fff;
		color: #2d8cf0;
		box-shadow: 0 6px 14px rgba(31, 65, 105, .08);
	}

	.login-card>>>.input {
		width: 100%;
		height: 44px;
		margin-bottom: 12px;
		padding: 0 14px;
		border: 1px solid #dce5ef;
		border-radius: 10px;
		box-sizing: border-box;
		outline: none;
		font-size: 14px;
		background: #fff;
	}

	.login-card>>>.input:focus {
		border-color: #2d8cf0;
		box-shadow: 0 0 0 3px rgba(45, 140, 240, .12);
	}

	.login-card>>>.btn,
	.login-card>>>.upload-btn {
		width: 100%;
		height: 44px;
		border: none;
		border-radius: 10px;
		background: linear-gradient(135deg, #2d8cf0, #42b4f5);
		color: #fff;
		font-size: 15px;
		font-weight: 800;
		cursor: pointer;
		box-shadow: 0 10px 22px rgba(45, 140, 240, .24);
	}

	.login-card>>>.scan-box {
		min-height: 132px;
		padding: 8px 0 0;
	}

	.login-card>>>.tip {
		min-height: 24px;
		margin-top: 12px;
		color: #2d8cf0;
	}

	.login-card>>>.select-user-wrapper {
		min-height: 240px;
	}

	@media (max-width: 640px) {
		.login-page {
			padding: 14px;
			align-items: flex-start;
			padding-top: 7vh;
		}

		.login-card {
			min-height: 410px;
			padding: 22px;
			border-radius: 16px;
		}

		.title {
			margin-bottom: 16px;
		}

		.title h1 {
			font-size: 21px;
			line-height: 1.25;
		}
	}
	.business-wrap {
	  position: absolute;
	  bottom: 10px;
	  right: 10px;
	  /* 给hover生效的父容器 */
	}
	
	.business-text {
	  font-weight: 800;
	  color: #2d8cf0;
	  cursor: pointer;
	  user-select: none;
	}
	
	.business-img {
	  position: absolute;
	  /* 控制图片弹出位置：在文字上方，向右偏移，按需修改top/left */
	  bottom: 24px;
	  right: 0;
	  width: 140px;
	  height: auto;
	  border-radius: 4px;
	  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
	  /* 默认隐藏 */
	  display: none;
	  z-index: 999;
	}
	
	/* 父容器hover，图片显示 */
	.business-wrap:hover .business-img {
	  display: block;
	}
</style>